// @NOTE this way to set the styles no longer works for components,
// since material changed the way it handles disabled and errored states
// If we need to support light and dark colors/background for texts we'll need to handle
// dark and light themes, and render components on the theme context. I'm patching fow now,
// to avoid showing orange colors to our users. But this is far from the best/correct solution.
const styles = (theme) => ({
  'light-textFieldRoot': {
    backgroundColor: theme.colors.text_secondary_background,
    '&.Mui-error': {
      border: `1px solid ${theme.colorPalette.red_50}`,
      '& input': {
        color: theme.colorPalette.red_50
      }
    }
  },
  'light-textFieldInput': {
    color: theme.colors.text_secondary
  },
  'light-textFieldDisabled': {
    color: `${theme.colorPalette.green_10} !important`,
    '&.Mui-error': {
      '& input': {
        color: `${theme.colorPalette.red_50} !important`
      }
    }
  },
  'light-labelRoot': {
    color: theme.colors.text_disabled,
    zIndex: 1
  },
  'light-labelShrink': {
    color: theme.colors.text_secondary,
    zIndex: 1
  },
  'light-labelDisabled': {
    color: `${theme.colors.text_secondary} !important`
  },
  'light-labelFocused': {
    color: `${theme.colors.text_secondary} !important`
  },
  'light-textFieldError': {
    border: `1px solid ${theme.colors.error} !important`,
    borderRadius: theme.spacing(1),
    boxShadow: 'none !important',
    '& textarea': {
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important'
    }
  },
  'light-labelError': {
    color: `${theme.colors.error} !important`
  },
  'dark-labelRoot': {
    minWidth: 195
  },
  'dark-textFieldDisabled': {
    color: `${theme.colorPalette.white_10} !important`
  },
  'dark-labelDisabled': {
    color: `${theme.colorPalette.white_10} !important`
  },
  'red-labelShrink': {
    color: theme.colorPalette.white
  },
  'red-textFieldRoot': {
    backgroundColor: theme.colors.white
  },
  'red-textFieldInput': {
    color: theme.colors.text_secondary,
    zIndex: 2
  }
});

export default styles;
